import React from 'react';
import {
    Slider as NativeSlider,
    ISliderProps,
    Box,
    Image
} from 'native-base';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@springbig/shared';
import { SpIcon } from './Icon';
import { Caption } from './Typography';

export type DefaultValuesPointsProps = {
    value: number;
    label: string;
    divisbleValue?: number;
};

export interface SliderProps extends ISliderProps {
    defaultValue?: number;
    valuePoints?: DefaultValuesPointsProps[];
    dots?: boolean;
    maxValue?: number;
}

const SliderBar = ({
    dots,
    valuePoints,
    defaultValue,
    maxValue
}: SliderProps) => {

    const {
        primary,
        background_secondary,
    } = useTheme();

    const logicCalculateColor = (value: number) => {

        if (defaultValue && defaultValue >= value) {
            return primary;
        }

        return background_secondary;
    };

    return (
        <Box w={'80%'} pt={4}>
            {
                defaultValue >= 0 && (
                    <Slider defaultValue={defaultValue} maxValue={maxValue} />
                )
            }
            { dots && valuePoints && valuePoints.length > 0 && valuePoints.map((point, index) => {

                const divisor = point.divisbleValue ? point.divisbleValue : 1;
                return (
                    <Box key={index} position={'absolute'} top={'19%'} left={`${divisor * 97}%`}  pt={4}>
                        <SpIcon
                            color={logicCalculateColor(point.value)}
                            icon={faCircle}
                            size={10}
                        />
                        <Caption
                            textAlign={'center'}
                            fontSize={12}
                        >
                            { point.label }
                        </Caption>
                    </Box>
                );
            })}
        </Box>
    );
};

const Slider = ({ defaultValue, maxValue }: SliderProps) => {

    const {
        primary,
        background_secondary,
        radius_sm,
        text,
        milestones_ticker,
    } = useTheme();

    return (
        <NativeSlider
            isReadOnly={true}
            bg={'transparent'}
            value={defaultValue}
            defaultValue={defaultValue}
            maxValue={maxValue}
            size={'lg'}
        >
            <NativeSlider.Track
                rounded={radius_sm}
                bg={maxValue > 0 ? background_secondary : primary}
                minH={3}
                borderWidth={2}
                borderColor={text}
            >
                <NativeSlider.FilledTrack
                    bg={primary}
                    borderRadius={'lg'}
                    minH={3}
                    borderWidth={defaultValue === maxValue ? 0 : 2}
                    borderColor={text}
                    left={defaultValue === maxValue ? 0 : -2}
                    top={-1}
                />
            </NativeSlider.Track>
            <NativeSlider.Thumb
                borderWidth={0}
                bg="transparent"
                borderColor="transparent"
                pointerEvents="none"
            >
                <Box
                    position="absolute"
                    bottom={3}
                    alignItems="center"
                    justifyContent="center"
                    bg="transparent"
                >
                    {milestones_ticker?.url ?
                        <Image
                            source={{ uri: milestones_ticker?.url }}
                            resizeMode="cover"
                            w={'4'}
                            h={'4'}
                            left={defaultValue === 0 ? 0 : -12}
                            borderRadius="full"
                        /> :
                        <Box
                            h="4"
                            w="4"
                            borderRadius="full"
                            bg={primary}
                            left={defaultValue === 0 ? 0 : -12}
                        />
                    }
                </Box>
            </NativeSlider.Thumb>
        </NativeSlider>
    );
};

export default SliderBar;

